import { render, staticRenderFns } from "./index.vue?vue&type=template&id=feab8738&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=feab8738&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feab8738",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feab8738')) {
      api.createRecord('feab8738', component.options)
    } else {
      api.reload('feab8738', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=feab8738&scoped=true&", function () {
      api.rerender('feab8738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/badgeList/index.vue"
export default component.exports